/**
 * @generated SignedSource<<7d14a1a1d8728c3ecb94cf6aee68995f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletionReason = "AUTO" | "MANUAL";
export type DeleteNoteModalDeleteTranscriptAndVideoMutation$variables = {
  recordingId: string;
};
export type DeleteNoteModalDeleteTranscriptAndVideoMutation$data = {
  readonly deleteMeetingRecordingTranscriptAndVideo: {
    readonly meetingRecording: {
      readonly id: string;
      readonly meetingRecordedVideoDuration: number | null;
      readonly meetingRecordedVideoPosterUrl: string | null;
      readonly meetingRecordedVideoUrl: string | null;
      readonly meetingRecordingVideoDeletionReason: DeletionReason | null;
      readonly transcript: any | null;
      readonly transcriptDeletionReason: DeletionReason | null;
    };
  } | null;
};
export type DeleteNoteModalDeleteTranscriptAndVideoMutation = {
  response: DeleteNoteModalDeleteTranscriptAndVideoMutation$data;
  variables: DeleteNoteModalDeleteTranscriptAndVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "recordingId"
      }
    ],
    "concreteType": "DeleteMeetingRecordingTranscriptAndVideo",
    "kind": "LinkedField",
    "name": "deleteMeetingRecordingTranscriptAndVideo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecording",
        "kind": "LinkedField",
        "name": "meetingRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transcript",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transcriptDeletionReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordedVideoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordedVideoPosterUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordedVideoDuration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordingVideoDeletionReason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNoteModalDeleteTranscriptAndVideoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNoteModalDeleteTranscriptAndVideoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9dcd0648b0d0339f9b6f0f4a13b28dc6",
    "id": null,
    "metadata": {},
    "name": "DeleteNoteModalDeleteTranscriptAndVideoMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNoteModalDeleteTranscriptAndVideoMutation(\n  $recordingId: ID!\n) {\n  deleteMeetingRecordingTranscriptAndVideo(meetingRecordingId: $recordingId) {\n    meetingRecording {\n      id\n      transcript\n      transcriptDeletionReason\n      meetingRecordedVideoUrl\n      meetingRecordedVideoPosterUrl\n      meetingRecordedVideoDuration\n      meetingRecordingVideoDeletionReason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac7c4d87e506589db35cc9fdcdb49f2b";

export default node;
